import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import styles from '../ForInvestors.module.scss';
import messages from '../ForInvestors.intl';
import DateAndTitleListItem from 'common/components/DateAndTitleListItem/DateAndTitleListItem';
import CurrentReportsStore from 'stores/CurrentReports.store';
import LanguageService from 'services/Language.service';
import { ANCHOR } from 'common/consts/common';

@injectIntl
@observer
export default class LatestCurrentReports extends Component {
  state = {
    latestReports: []
  };

  componentDidMount() {
    this.getLatestReports();
  }

  getLatestReports = async () => {
    const currentLanguage = LanguageService.getLang();
    const { data } = await CurrentReportsStore.fetchLatestCurrentReports({
      limit: 3,
      publishYear: ''
    });
    const latestReports = data.map(item => {
      const date = new Date(item.publicationDate);
      const year = date.getFullYear();
      return {
        title: item.title,
        date: {
          day: date.getDate(),
          month: date
            .toLocaleString(currentLanguage === 'pl' ? 'pl-PL' : 'en-US', {
              month: 'short'
            })
            .toUpperCase(),
          year
        },
        link: `${ANCHOR.CURRENT_REPORTS[currentLanguage]}/${year}/${item.slug}`
      };
    });
    this.setState({
      latestReports
    });
  };

  render() {
    const { latestReports } = this.state;
    return (
      <div>
        <h2 className={styles.Header}>
          {this.props.intl.formatMessage(messages.currentReportsTitle)}
        </h2>
        {latestReports &&
          latestReports.map(({ date, title, link }, index) => (
            <DateAndTitleListItem
              date={date}
              link={link}
              title={title}
              key={index}
            />
          ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ForInvestors/components/LatestCurrentReports.js